/**
 * /r/<iso2>  — Country-shortcut redirect.
 *
 * Looks up the ISO-3166 alpha-2 code, derives a centroid lat/lon,
 * and forwards to /threat-radar with `?lat=…&lon=…&country=…` so the
 * globe pre-pans to that region without doing a geo-lookup.
 *
 * Examples:
 *   /r/de  → /threat-radar?lat=51.2&lon=10.45&country=DE
 *   /r/jp  → /threat-radar?lat=36.2&lon=138.3&country=JP
 *
 * Unknown codes redirect to /threat-radar with no params (default view).
 */
import { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import COUNTRY_CENTROIDS from "../data/countryCentroids";

export default function RegionRedirect() {
  const { code } = useParams();
  const upper = (code || "").toUpperCase();
  const c = COUNTRY_CENTROIDS[upper];

  // Side-effect-free analytics breadcrumb so we can see /r/<code> traffic
  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      window.dispatchEvent(new CustomEvent("qortrace:region-shortcut", {
        detail: { code: upper, matched: !!c },
      }));
    } catch (_e) { /* ignore */ }
  }, [upper, c]);

  if (!c) {
    return <Navigate to="/threat-radar" replace />;
  }
  const params = new URLSearchParams({
    lat:     String(c.lat),
    lon:     String(c.lon),
    country: upper,
  });
  return <Navigate to={`/threat-radar?${params.toString()}`} replace />;
}
